import { configureStore } from '@reduxjs/toolkit'
import { useStore } from 'react-redux'
import restClient from 'Shared/hooks/restClient'

import app from './store/app'
import dashboard from './store/dashboard'
import dashboardTargets from './store/dashboardTargets'
import local from './store/local'

// the reducers and actions for each slice are stored together in slices/sliceName.js
const slices = {
  app,
  dashboard,
  dashboardTargets,
  local
}

const store = configureStore({
  reducer: _.mapValues(slices, (slice) => slice.reducer),
  devTools: {
    name: 'Dashboard user',
  },
})

const useAct = () => {
  const dis = useDis()
  const store = useStore()

  return useMemo(
    () => _.mapValues(slices, (fn) => {
      return fn.actions(dis, store, restClient)
    }),
    []
  )
}

export { store, useAct }
